import { useEffect, useState } from "react"
import axios from "axios"
import { CloseIcon } from "./assets/CommonIcons"

const ContactForm = ({ setContactOpen, imv }) => {
	const handleSubmit = async () => {
		try {
			await axios.post('https://oxx-api.vercel.app/faiimoveis_/contatos/', contactData, {
				headers: {
					'api-key': 'xUp2jAz5hQZM#wCsKb',
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			})

			setContactOpen(false)
		} catch (e) {
			window.alert('Nao foi Possivel Entrar em Contato, Certifique-se de que os Campos Estão Preenchidos')
		}
	}

	const handleChange = (field, e) => {
		setContactData((prevData) => ({
			...prevData,
			[field]: e.target.value
		}))
	}

	const [contactData, setContactData] = useState({
		nome: '',
		tel: '',
		email: '',
		message: ''
	})

	useEffect(() => {
		if (imv) {
			setContactData((prevData) => ({
				...prevData,
				message: `Gostaria de Saber Sobre o Imovel ${imv.nreg}, localizado em ${imv.end}`
			}));
		} else {

		}
	}, []);

	return (<>
		<form method='post' action={() => 'enviado'} className='xl:w-1/4 h-2/3 z-40 max-lg:w-full max-sm:w-full bg-[#8d8d8d73] rounded-lg'>
			<div onClick={() => setContactOpen(false)} className="flex pt-5 pl-5 h-14 w-14 cursor-pointer fill-white transition-[fill] hover:fill-[#af1c1c]">
				<CloseIcon />
			</div>
			<h1 className="p-5 text-3xl text-center font-thin"> Informaçoes de Contato: </h1>
			<div className="grid gap-y-5 p-10 w-full items-center">
				<fieldset className="grid ">
					<label className="text-left"> Nome: </label>
					<input className="p-2 text-black rounded-lg" onChange={(e) => handleChange('nome', e)} type='text' placeholder='Seu Nome' required />
				</fieldset>

				<fieldset className="grid ">
					<label className="text-left"> Celular: </label>
					<input className="p-2 text-black rounded-lg" onChange={(e) => handleChange('tel', e)} type='text' placeholder='Telefone ou Celular' required />
				</fieldset>

				<fieldset className="grid ">
					<label className="text-left"> Email: </label>
					<input className="p-2 text-black rounded-lg" onChange={(e) => handleChange('email', e)} type='email' placeholder='Email (Opcional)' />
				</fieldset>

				<fieldset className="grid ">
					<label className="text-left"> Mensagem: </label>
					<textarea className="p-2 text-black h-40 rounded-lg" onChange={(e) => handleChange('message', e)}
						placeholder="Informaçoes Sobre Imóveis, opçoes de financiamento, condiçoes de pagamento, etc" required>
						{
							imv && `Gostaria de Mais Informaçôes Sobre o Imóvel ${imv.nreg} Localizado na ${imv.end}`
						}
					</textarea>
				</fieldset>
			</div>

			<button className="bg-[#338d4e] p-3 w-full rounded-b-lg text-xl text-center cursor-pointer" onClick={() => handleSubmit()}>
				Enviar
			</button>
		</form>
	</>)
}

export default ContactForm